import React from 'react'
import {
    FormControl,
    MenuItem,
    Select,
    Grid,
    Typography,
} from '@material-ui/core'
import {
    PERIODICITY_ALL_TYPE_EXCHANGE_UUID,
    PERIODICITY_RECIPROCAL_EXCHANGE_UUID,
    PERIODICITY_NO_RECIPROCAL_EXCHANGE_UUID
} from 'src/configs'
import { useIntl } from 'src/common/razzle-platform-translate'

function PeriodicityFilter(props) {
    const { onChange, filters, clearFilter, periodicities } = props
    const { formatMessage } = useIntl()
    const allExchangeTypePeriodicity = _.find(periodicities, {uuid: PERIODICITY_ALL_TYPE_EXCHANGE_UUID})
    const noReciprocalPeriodicity = _.find(periodicities, {uuid: PERIODICITY_NO_RECIPROCAL_EXCHANGE_UUID})
    const reciprocalPeriodicity = _.find(periodicities, {uuid: PERIODICITY_RECIPROCAL_EXCHANGE_UUID})

    const handleChange = (event) => {
        const selectedValue = event.target.value

        if (selectedValue === reciprocalPeriodicity.id) {
            onChange({ 'availabilities.event.periodicity.ne_id': noReciprocalPeriodicity.id })
        } else if (selectedValue === noReciprocalPeriodicity.id) {
            onChange({ 'availabilities.event.periodicity.ne_id': reciprocalPeriodicity.id })
        } else {
            clearFilter(['availabilities.event.periodicity.ne_id'])
        }
    }

    if (_.isEmpty(periodicities)) {
        return null
    }

    let value = _.get(filters, 'availabilities.event.periodicity.ne_id')

    if (value === reciprocalPeriodicity.id) {
        value = noReciprocalPeriodicity.id
    } else if (value === noReciprocalPeriodicity.id) {
        value = reciprocalPeriodicity.id
    } else {
        value = allExchangeTypePeriodicity.id
    }

    return (
        <React.Fragment>
            <Grid container spacing={4} alignItems="center" style={{marginBottom: 16, marginTop: 16}}>
                <Grid item md={5} xs={12}>
                    <Typography>{formatMessage({
                        id: "Periodicity type",
                        defaultMessage: "Periodicity type"
                    })}</Typography>
                </Grid>
                <Grid item md={7} xs={12}>
                    <FormControl variant="outlined" fullWidth>
                        <Select
                            defaultValue={value}
                            fullWidth
                            value={value}
                            onChange={handleChange}
                        >
                            {periodicities && periodicities.map(periodicity => <MenuItem value={periodicity.id}>{periodicity.label}</MenuItem>)}
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>

        </React.Fragment>
    )
}

export default PeriodicityFilter
